import { useState } from "react";
import Layout from "../../components/layout";
import PageHeading from "../../components/page-header";
import { sendContactForm } from "../../lib/api";

const initialValues = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    message: '',
};

const initState = { values: initialValues };

export default function Contact() {
  const [state, setState] = useState(initState);
  const { values, isLoading } = state;

  const [emailError, setEmailError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = ({ target }) =>
    setState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        [target.name]: target.value,
      },
    }));

  // Email validation function
  const isValidEmail = (email) => {
      // Simple email regex
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      setSuccessMessage('');
      if (!isValidEmail(values.email)) {
          setEmailError('Please enter a valid email address.');
          return;
      }
      setEmailError('');
      setState((prev) => ({
          ...prev,
          isLoading: true,
      }));
      try {
        await sendContactForm(values);
        setSuccessMessage('Your message has been sent successfully!');
        setState({ values: initialValues, isLoading: false });
      } catch (error) {
        setSuccessMessage('There was an error sending your message. Please try again.');
        setState((prev) => ({
          ...prev,
          isLoading: false,
        }));
      }
  };

  return (
      <Layout>
          <PageHeading heading_text="Contact Us" />

          <div className="section black-bg">
              <div className="container">
                  <div className="row g-5 justify-content-center align-items-center">
                      <div className="col-12">
                          <div className="heading-frame">
                              <div className="border-frame tr"></div>
                              <h2 className="text-center">
                                  Empowering Environments Through Seamless AV Innovation.
                              </h2>
                              <div className="border-frame bl"></div>
                          </div>
                      </div>
                      <div className="col-12">
                          <div className="form-container">
                              <h2>Contact Us</h2>
                              <form action="#" method="post" onSubmit={handleSubmit}>
                                  <label htmlFor="fname">First Name</label>
                                  <input
                                      type="text"
                                      id="fname"
                                      name="first_name"
                                      required
                                      value={values.first_name}
                                      onChange={handleChange}
                                  />

                                  <label htmlFor="lname">Last Name</label>
                                  <input
                                      type="text"
                                      id="lname"
                                      name="last_name"
                                      required
                                      value={values.last_name}
                                      onChange={handleChange}
                                  />

                                  <label htmlFor="phone">Phone Number</label>
                                  <input
                                      type="tel"
                                      id="phone"
                                      name="phone"
                                      required
                                      value={values.phone}
                                      onChange={handleChange}
                                  />

                                  <label htmlFor="email">Email</label>
                                  <input
                                      type="email"
                                      id="email"
                                      name="email"
                                      required
                                      value={values.email}
                                      onChange={(e) => {
                                          handleChange(e);
                                          if (emailError) setEmailError('');
                                      }}
                                  />
                                  {emailError && (
                                      <div style={{ color: 'red', marginBottom: '10px' }}>{emailError}</div>
                                  )}

                                  <label htmlFor="message">Message</label>
                                  <textarea
                                      id="message"
                                      name="message"
                                      rows="5"
                                      required
                                      value={values.message}
                                      onChange={handleChange}
                                  ></textarea>

                                  <button type="submit" disabled={isLoading}>
                                    {isLoading ? 'Sending...' : 'Send'}
                                  </button>
                              </form>
                              {successMessage && (
                                <div style={{ color: 'green', marginTop: '15px' }}>{successMessage}</div>
                              )}
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </Layout>
  );
}
